import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SearchForm from "components/SearchForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocationsThunk,
  locationSelector,
} from "store/reducers/inventory/locationSlice";
import { machineAssignmentToLocationThunk } from "store/reducers/machine_func/machineAssignmentToLocation";

const AssignMachineToLocationDialog = ({ open, handleClose, machine_id }) => {
  const [search, setSearch] = React.useState("");
  const dispatch = useDispatch();
  const locations = useSelector(locationSelector.selectAll);
  useEffect(() => {
    console.log({ search });
  }, [search]);
  const { machineAssignmentLocationLoading } = useSelector(
    (state) => state.vending
  );

  const machine = useSelector((state) => state.vending.machines).find(
    (item) => item.id === machine_id
  );

  useEffect(() => {
    dispatch(getLocationsThunk());
  }, [dispatch]);

  const assignLocation = (location) => {
    dispatch(
      machineAssignmentToLocationThunk({
        machine: machine.id,
        location: location.id,
      })
    );
  };

  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Select location to assign"
    >
      <Box paddingX={2}>
        <SearchForm
          hint="Search kitchen"
          submitSearch={setSearch}
          sx={{ marginY: 2 }}
        />
      </Box>
      {locations.length > 0 ? (
        <>
          {locations
            .filter((item) =>
              item.name.toLowerCase().includes(search.toLowerCase())
            )
            .map((location) => (
              <Stack
                justifyContent="space-between"
                margin={2}
                direction="row"
                alignItems="center"
                key={location.id}
              >
                <Typography variant="body1">{location.name}</Typography>
                {machine?.location === location.name ? (
                  <LoadingButton
                    variant="outlined"
                    size="small"
                    loading={machineAssignmentLocationLoading[location.id]}
                    onClick={() => assignLocation(location)}
                    disabled
                  >
                    Assigned
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    variant="outlined"
                    size="small"
                    loading={machineAssignmentLocationLoading[location.id]}
                    onClick={() => assignLocation(location)}
                  >
                    Assign
                  </LoadingButton>
                )}
              </Stack>
            ))}
        </>
      ) : (

        <Typography textAlign="center"> No items </Typography>

      )}
    </CustomDialog>
  );
};

export default AssignMachineToLocationDialog;
